import React, { useEffect, useState } from 'react';
import axios from 'axios';
import JobDisplayer from './JobDisplayer';
import { useUser } from '../contexts/UserContext';
import { timeAgo } from '../shared/utility/timeAgo';
import {
    Box,
    Typography,
    Alert
} from '@mui/material';


const formatSeconds = (seconds) => {
    if (seconds == null || isNaN(seconds)) return 'N/A';

    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
};

const JobMonitorComponent = () => {
    const { user } = useUser();
    const [jobs, setJobs] = useState([]);
    const [error, setError] = useState('');
    const [intervalId, setIntervalId] = useState(null);
    const [expandedJobs, setExpandedJobs] = useState({});

    const toggleExpanded = (jobId) => {
        setExpandedJobs(prev => ({
            ...prev,
            [jobId]: !prev[jobId]
        }));
    };

    const fetchJobs = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs`, {
                headers: { Authorization: `Bearer ${user.token}` }
            });
            setJobs(response.data);
        } catch (err) {
            setError(err.response?.data?.message || 'Error fetching jobs');
        }
    };

    useEffect(() => {
        if (!user.token || !user.hasRoles(['jedimaster'])) return;

        fetchJobs();
        const id = setInterval(fetchJobs, 5000);
        setIntervalId(id);

        return () => clearInterval(id);
    }, [user]);

    if (!user.token || !user.hasRoles(['jedimaster'])) {
        return <Typography>Only administrators can view jobs.</Typography>;
    }

    return (
        <Box sx={{ mt: 4 }}>
            <Typography variant="h6" gutterBottom>
                Active Job Monitor - all failed shown, but only most recent successes (6 hours)
            </Typography>

            {error && <Alert severity="error">{error}</Alert>}

            {jobs.map(job => (
                <JobDisplayer
                    key={job.id}
                    job={job}
                    isExpanded={!!expandedJobs[job.id]}
                    onToggle={toggleExpanded}
                    timeAgo={timeAgo}
                    formatSeconds={formatSeconds}
                />
            ))}

            {jobs.length === 0 && <Typography>No jobs found.</Typography>}
        </Box>
    );
};

export default JobMonitorComponent;
